import { Grid, TextField, MenuItem, InputLabel } from '@material-ui/core';
import type { StyledComponentProps } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import FieldHidden from '@react-form-fields/material-ui/components/Hidden';
import CustomMaskedInput from 'components/MaskedInput';
import { functions } from 'helpers';
import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { FormContent } from 'scenes/Producer/Product/EditProduct/components/FormContent';
import styles from 'scenes/Producer/Product/NewProduct/components/Forms/styles';
import { EChargeType, EProductType } from 'v2/interfaces/product';
import eduzzAccountsService from 'v2/services/eduzzAccount';
import { run } from 'validations/ruleRunner';

import Subscription from './components/Subscription';
import Validations from './validations';

import type IProduct from 'interfaces/IProduct';
import type { DispatchProp } from 'react-redux';

interface IProps extends IPropsFromConnect, DispatchProp<any>, StyledComponentProps {
  product: IProduct;
  enabledValidation: boolean;
  handleChange?: any;
  currencyList?: any;
  setRefField?: any;
  setRefError?: any;
}

interface IPropsFromConnect {
  currentUser: any;
}

interface IStates {
  showErrors: boolean;
  validationErrors: any;
  userHasAccessToSubscriptionModule: boolean;
}

class Sale extends Component<IProps, IStates> {
  constructor(props: any) {
    super(props);
    this.state = {
      showErrors: false,
      validationErrors: [],
      userHasAccessToSubscriptionModule: false,
    };
  }

  getPriceHelperText = () => {
    if (this.isValid('price')) return this.errorFor('price');
    const isInfo = this.props.product.type === EProductType.DIGITAL;
    const isSinglePayment = this.props.product.charge_type === EChargeType.SINGLE;
    if (isInfo && isSinglePayment) {
      return 'Você poderá cadastrar o preço de venda inclusive para moedas estrangeiras na Edição';
    }
    return 'EX: 1.000,00';
  };

  errorFor = (field: any) => {
    return this.state.validationErrors[field] || '';
  };

  isValid = (field: any) => {
    return this.state.validationErrors[field] ? true : false;
  };

  componentDidUpdate(prevProps: IProps) {
    const { product } = this.props;

    if (
      (prevProps.enabledValidation === false && this.props.enabledValidation && product.charge_type === 'N') ||
      (product !== prevProps.product && product.charge_type === 'N')
    ) {
      let newState = { ...this.state };
      newState.validationErrors = run(product, Validations);
      this.setState(newState);
    }
  }

  componentDidMount() {
    let getSubscriptionBetaModuleStatus = eduzzAccountsService.verifyUserHasBetaModule('planos_assinatura');

    this.setState({ userHasAccessToSubscriptionModule: getSubscriptionBetaModuleStatus });
  }

  render() {
    const { handleChange, product, currencyList, setRefField, setRefError, classes, currentUser } = this.props;
    const { userHasAccessToSubscriptionModule } = this.state;

    const allowRecurrence =
      product.type === EProductType.DIGITAL ||
      product.type === EProductType.SERVICE ||
      (currentUser.subscription_physical && product.type === EProductType.PHYSICAL);

    const allowOpenValue = product.type === EProductType.DIGITAL || product.type === EProductType.SERVICE;

    return (
      <FormContent title='Formas de cobrança' loading={false}>
        <Grid container spacing={2} alignItems='center'>
          <Grid item xs={12}>
            <div>
              <TextField
                id='new-product-charge-type'
                select
                fullWidth
                value={product.charge_type}
                onChange={(e: any) => handleChange('charge_type', e.target.value)}
                label='Tipo de cobrança *'
                InputProps={{
                  disableUnderline: true,
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              >
                <MenuItem value={EChargeType.SINGLE}>Única</MenuItem>
                {allowRecurrence && !userHasAccessToSubscriptionModule && (
                  <MenuItem value={EChargeType.SUBSCRIPTION}>Assinatura/Recorrência</MenuItem>
                )}
                {allowOpenValue && <MenuItem value={EChargeType.OTHER}>Valor Aberto</MenuItem>}
                {product.type !== EProductType.PHYSICAL && <MenuItem value={EChargeType.FREE}>Gratuito</MenuItem>}
              </TextField>
            </div>
          </Grid>
          {product.charge_type === EChargeType.SINGLE && (
            <Fragment>
              <Grid item xs='auto' style={{ alignSelf: 'baseline' }}>
                <div className={classes.brlCurrencyContainer}>
                  <InputLabel>Moeda</InputLabel>
                  <Typography variant='body1'>BRL (Real Brasileiro)</Typography>
                </div>
                <FieldHidden
                  name='preço'
                  ref={(ref: any) => setRefError('price', ref)}
                  value={functions.clearMoneyMask(product.price)}
                  validation='required|numeric|min:1'
                />
              </Grid>
              <Grid className={classes.priceContainer} item xs={12} sm='auto'>
                <CustomMaskedInput
                  label='Preço *'
                  fullWidth={true}
                  disableUnderline
                  id='new-product-price'
                  mask='money'
                  helperText={this.getPriceHelperText()}
                  error={this.isValid('price')}
                  value={product.price}
                  onChange={(value: any) => handleChange('price', value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    maxLength: 20,
                  }}
                  startAdornment='R$'
                  ref={(ref: any) => setRefField('price', ref)}
                />
              </Grid>
            </Fragment>
          )}
          {product.charge_type === EChargeType.SUBSCRIPTION && (
            <Subscription
              product={product}
              handleChange={handleChange}
              currencyList={currencyList}
              setRefField={setRefField}
              setRefError={setRefError}
              enabledValidation={this.props.enabledValidation}
            />
          )}
          {product.charge_type === EChargeType.OTHER && (
            <Grid item xs={12}>
              <p>
                O valor <strong>minímo</strong> no checkout será de R$ 5,00
              </p>
              <p>Não será habilitado o parcelamento no checkout</p>
            </Grid>
          )}
          {product.charge_type === EChargeType.FREE && (
            <>
              <Grid item xs={12} md={2}>
                <div>
                  <img src='/img/eduzzinho-thumbsup.png' alt='Eduzzinho' width='100px' style={{ marginRight: '50px' }} />
                </div>
              </Grid>
              <Grid item xs={12} md={10}>
                <b>Eba! Produto gratuito.</b>
                <p>Produto gratuito é uma ótima maneira de captar leads, você pode utilizar como produto de entrada para outro produto pago.</p>
              </Grid>
            </>
          )}
        </Grid>
      </FormContent>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    currentUser: state.orbita.User.user.user,
  };
}
export default styles(connect(mapStateToProps)(Sale)) as any;
